import * as z from "zod";

export const getSpsCommerceAuthorizationUrl = {
  name: "getSpsCommerceAuthorizationUrl" as const,
  input: z.object({}),
  output: z.object({
    installAttemptNonce: z.string().uuid(),
    url: z.string().url(),
  }),
};
